import { Box, styled } from '@mui/material';
import type { BoxProps } from '@mui/material';
import { ArrowUpIcon } from '../icons';

export type SortDirection = 'asc' | 'desc' | 'none';

export type SortableLabelProps = Omit<BoxProps, 'onClick'> & {
    readonly sort: SortInfo;
    readonly sortKey: string;
    onSortAction(sortKey: string): void;
};
export type SortInfo<T extends string = string> = {
    key: T;
    direction: SortDirection;
};

const SortableLabel = styled((props: SortableLabelProps) => {
    const { children, sort, onSortAction, sortKey, ...boxProps } = props;
    const sortDirection = sort.key === sortKey ? sort.direction : 'none';

    return (
        <Box
            display="flex"
            alignItems="center"
            gap={0.5}
            color={sortDirection !== 'none' ? 'primary.main' : 'text.secondary'}
            onClick={() => onSortAction(sortKey)}
            {...boxProps}
        >
            <span>{children}</span>
            <ArrowUpIcon
                size={12}
                sx={{
                    transform: `scaleY(${
                        sortDirection === 'asc'
                            ? -1
                            : sortDirection === 'desc'
                              ? 1
                              : 0
                    })`,
                    transition: 'transform 0.25s',
                }}
            />
        </Box>
    );
})({
    fontSize: 12,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    cursor: 'pointer',
    hyphens: 'auto',
});

export default SortableLabel;
